import { cn } from '@utils/helpers';
import { XIcon } from 'lucide-react';
import { useRef } from 'react';
import { useFragment } from 'react-relay';
import { liveFilterFragment } from './LiveFilter.relay';
import type { LiveFilterPropsType } from './types';

const LiveFilter: React.FC<LiveFilterPropsType> = (props: LiveFilterPropsType) => {
  const liveFilter = useFragment(liveFilterFragment, props.liveFilter);
  const inputRef = useRef<HTMLInputElement>(null);

  const hasText = Boolean(props.filterText);

  const handleClear = () => {
    props.filterHandlerFn(props.filterCols, { target: { value: '' } });
    inputRef.current?.focus();
  };

  // The passed-in className styles the search "box" (border, padding, width, the
  // magnifier background icon). It lives on the wrapper so the wrapper can act as
  // the positioning context for the clear button while keeping the exact layout.
  // When there is text we hide the magnifier and show the clear button in its place.
  return (
    <div className={cn('relative flex items-center', props.className)} style={hasText ? { backgroundImage: 'none' } : undefined}>
      <input
        ref={inputRef}
        type="search"
        placeholder={liveFilter.placeholder || ''}
        value={props.filterText}
        onInput={props.filterHandlerFn.bind(null, props.filterCols)}
        onBlur={props.onBlur}
        className="w-full border-0 bg-transparent p-0 text-inherit outline-none [&::-webkit-search-cancel-button]:hidden"
      />
      {hasText && (
        <button type="button" aria-label="Löschen" onMouseDown={(e) => e.preventDefault()} onClick={handleClear} className="absolute right-[10px] top-1/2 flex -translate-y-1/2 items-center justify-center">
          <XIcon className="size-3 text-black hover:cursor-pointer" />
        </button>
      )}
    </div>
  );
};

export { LiveFilter };
